import React, { Component } from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import axios from 'axios'
import Helmet from 'react-helmet'
import MediaQuery from 'react-responsive'
import icon32 from '../images/favicon.png'
import { backendURL } from '../data/config.json'

//Components
import MainForm from '../components/MainForm/'

//Scroll animation
import ScrollAnim from 'rc-scroll-anim'
const ScrollParallax = ScrollAnim.Parallax

class FrontpageEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      mainImageEn: {
        title: '',
        url: '',
      },
    }
    this.renderBannersSecondSection = this.renderBannersSecondSection.bind(this)
    this.renderBannersThirdSection = this.renderBannersThirdSection.bind(this)
    this.renderBannersMeet = this.renderBannersMeet.bind(this)
  }
  componentDidMount() {
    axios
      .get(`${backendURL}/api/banners/page/Home`)
      .then(res => {
        const main = res.data.filter(data => data.section === 'Main')

        console.log(main[0].image)

        this.setState({
          loading: false,
          banners: res.data,
          mainImageEn: {
            title: main[0].title.en,
            url: main[0].imageEn,
          },
        })
      })

      .catch(err => {
        console.log(err)
      })
  }


  renderBannersSecondSection() {
    const { banners } = this.state
    return _.map(banners, (banner, i) => {
      const { title, imageEn, published, section, link } = banner
      console.log(link)
      const { langKey: lang } = this.props.pathContext
      if (published && section === 'Second-Section') {
        if (link) {
          return (
            <div key={i}>
              <a href={link.en}>
                <img src={`${backendURL}${imageEn}`} alt={title[lang]} />
              </a>
            </div>
          )
        } else {
          return (
            <div key={i}>
              <img src={`${backendURL}${imageEn}`} alt={title[lang]} />
            </div>
          )
        }

        return null
      }
    })
  } 

 

  renderBannersThirdSection() {
    const { banners } = this.state
    return _.map(banners, (banner, i) => {
      const { title, imageEn, published, section, link } = banner
      const { langKey: lang } = this.props.pathContext
      if (published && section === 'Third-Section') {
        if (link) {
          return (
            <div key={i}>
              <a href={link.en}>
                <img src={`${backendURL}${imageEn}`} alt={title[lang]} />
              </a>
            </div>
          )
        } else {
          return (
            <div key={i}>
              <img src={`${backendURL}${imageEn}`} alt={title[lang]} />
            </div>
          )
        }

        return null
      }
    })
  }

  renderBannersMeet() {
    const { banners } = this.state
    return _.map(banners, (banner, i) => {
      const { title, imageEn, published, section } = banner
      const { langKey: lang } = this.props.pathContext
      if (published && section === 'Meet') {  
          return (
                <img src={`${backendURL}${imageEn}`} alt={title[lang]} />    
          )
        return null
      }
    })
  }

  render() {
    const { langKey: lang } = this.props.pathContext
    if (this.state.loading) {
      return null
    }
    return (
      <div className="page frontpage">
        <Helmet
          title={`Budget Nicaragua, The Best Choice for Truck and Car Rental`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals.',
            },
            { name: 'twitter:site', content: '#budgetNicaragua' },
            {
              name: 'twitter:descriptions',
              content:
                'Frequently Asked Questions about car rentals.',
            },
            {
              name: 'twitter:title',
              content:
                'Budget Nicaragua, The Best Choice for Truck and Car Rental',
            },
            { name: 'twitter:creator', content: '#budgetNicaragua' },

            {
              property: 'og:title',
              content:
                'Budget Nicaragua, The Best Choice for Truck and Car Rental',
            },
            {
              property: 'og:site_name',
              content: 'https://www.facebook.com/budgetNicaragua',
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:url',
              content: 'https://www.facebook.com/budgetNicaragua',
            },
            {
              property: 'og:description',
              content:
                'Frequently Asked Questions about car rentals.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'en',
              href: './es/index',
            },
            { rel: 'shortcut icon', type: 'image/png', href: `${icon32}` },
          ]}
        />

        <MainForm image={this.state.mainImageEn} lang={lang} />
        <div style={{background: '#F78621' , height: '55px', margin:'-30px 0 0 0', color:'#fff' ,padding:' 1% 0% 1% 0%', textAlign: 'center'}}>
          <p>
          Pay now and Save up to 35% and get our best rates guaranteed
          </p>
        </div>
        <div className="block-first">
          <div className="grid-wrapper">
            <div className="excerpt">
              <h2>Meet Our Fleet ></h2>
              <p>
                From luxury 4x4 to economy vehicles, we have the car you need.
              </p>
              <h3>
                <Link to="/en/fleet">Check out our selection</Link>
              </h3>
            </div>
            <MediaQuery query="(min-width: 780px)">
              <ScrollParallax
                animation={{ x: 0, opacity: 1 }}
                style={{
                  transform: 'translateX(100px)',
                  opacity: 0,
                }}
              >
               {this.renderBannersMeet()}
              </ScrollParallax>
            </MediaQuery>
            <MediaQuery query="(max-width: 780px)">
              <div>
              {this.renderBannersMeet()}
              </div>
            </MediaQuery>
          </div>
        </div>
        {/* Second Section */}
        <MediaQuery query="(max-width: 780px)">
          <div className="block-second">
          <h2 style={{marginLeft :'85px', color: '#fff', fontWeight:'bold'}} >Special Dealssssss</h2>
            <div className="grid-wrapper">
              {this.renderBannersSecondSection()}
            </div>
          </div>
        </MediaQuery>
        <MediaQuery query="(min-width: 780px)">
          <ScrollParallax animation={{ skewY: -15 }}>
            <div className="block-second">
            <h2 style={{marginLeft :'85px', color: '#fff', fontWeight:'bold'}} >Special Deals</h2>
              <ScrollParallax animation={{ skewY: 15 }}>
                <div className="grid-wrapper">
                  {this.renderBannersSecondSection()}
                </div>
              </ScrollParallax>
            </div>
          </ScrollParallax>
        </MediaQuery>
        {/* Third Section */}
        <MediaQuery query="(max-width: 780px)">
          <div className="third-block">
            <div className="grid-wrapper">
              {this.renderBannersThirdSection()}
            </div>
          </div>
        </MediaQuery>

        <div className="third-block">
          <div className="grid-wrapper">{this.renderBannersThirdSection()}</div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query FrontpageEnQuery {
    mainImg: imageSharp(id: { regex: "/frontpage-main/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default FrontpageEn



// WEBPACK FOOTER //
// ./src/pages/index.en.js